import type { TFunction } from 'i18next';

export const buyingMatchSubtitle = (
  row: {
    listing_count?: number;
    confirmed_listing_count?: number;
    unconfirmed_listing_count?: number;
  },
  t: TFunction,
): string => {
  const counts =
    row.confirmed_listing_count === undefined
      ? [['newLandingPage.activity.listings', row.listing_count ?? 0] as const]
      : [
          [
            'newLandingPage.activity.confirmedMatches',
            row.confirmed_listing_count,
          ] as const,
          [
            'newLandingPage.activity.possibleMatches',
            row.unconfirmed_listing_count ?? 0,
          ] as const,
        ];

  return counts
    .filter(([, count]) => count > 0)
    .map(([key, count]) => t(key, { count }))
    .join(' · ');
};
